import CartUtil from 'common/util/CartUtil';

class CartItemDeleteModal {
	static select = $context => $context.select('.cart-item-delete-modal');

	constructor($modal) {
		this.$modal = $modal;
		this.bindEvents();
	}

	bindEvents() {
		const self = this;

		self.$modal.on('click', '.cart-item-delete-modal__btn', function () {
			const itemId = $(this).data('id');

			if (itemId !== undefined) {
				if (itemId === 'all') {
					CartUtil.clear().then(() => {
						$('.cart-page').trigger('cleared');
						ModalUtil.close();
					});
				} else if (Array.isArray(itemId)){
					itemId.forEach((item) => {
						CartUtil.deleteItem(item).then(function () {
							$('.cart-item[data-item_id="' + item + '"]').trigger('delete_cart_item');
						});
					});
					ModalUtil.close();
				} else {
					CartUtil.deleteItem(itemId).then(function () {
						$('.cart-item[data-item_id="' + itemId + '"]').trigger('delete_cart_item');
						ModalUtil.close();
					});
				}
			}
		})
	}
}

export default () => Component(CartItemDeleteModal.select, $item => new CartItemDeleteModal($item));
